export function randomNormal(mean: number, standardDeviation: number){

    let u1 = Math.random();
    let u2 = Math.random();
    
    // Box-Muller transform
    let z0 = Math.sqrt(-2.0 * Math.log(u1)) * Math.cos(2.0 * Math.PI * u2);
    
    return z0 * standardDeviation + mean;
}

export function mod(n: number, m: number): number {
    return ((n % m) + m) % m;
}

export function hexToRgb(hex: string): number[] {
  
  hex = hex.replace(/^#/, "");

  
  if (hex.length === 3) {
    hex = hex
      .split("")
      .map((char) => char + char)
      .join("");
  }

  const num = parseInt(hex, 16);

  return [
    (num >> 16) & 255,
    (num >> 8) & 255,
    num & 255,
  ]
}